import styled from 'styled-components';

export const InfoWrapper = styled.div`
    display: flex;
    gap: 8px;
    align-items: center;
`;

export const InfoTitle = styled.span`
    white-space: nowrap;
`;

export const InfoText = styled.strong`
    white-space: nowrap;
`;
